// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getCustomersSettings = createAsyncThunk('customersSettings/getCustomersSettings', async () => {
  const response = await axios.get(`/v1/customers/settings`)
  return response.data
})

export const getCustomerSettings = createAsyncThunk('customersSettings/getCustomerSettings', async (customerId) => {
  const response = await axios.get(`/v1/customers/settings/${customerId}`)
  return response.data
})

export const updateCustomerSettings = createAsyncThunk('customersSettings/updateCustomerSettings', async ({ customerId, customerData }) => {
  try {
    const response = await axios.put(`/v1/customers/settings/${customerId}`, customerData)
    return response.data
  } catch (err) {
    // The API's reason (a refused value, or 403 for a read-only role), not axios' status line.
    throw new Error(err.response?.data?.message || (err.response?.status === 403 ? 'You can view these settings but not change them.' : err.message))
  }
})

export const appCustomersSettingsSlice = createSlice({
  name: 'customersSettings',
  initialState: {
    data: [],
    selectedCustomer: null,
    isLoading: false,
    isUpdating: false,
    error: null
  },
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getCustomersSettings.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getCustomersSettings.fulfilled, (state, action) => {
        state.data = action.payload
        state.isLoading = false
        state.error = null
      })
      .addCase(getCustomersSettings.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getCustomerSettings.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(getCustomerSettings.fulfilled, (state, action) => {
        state.selectedCustomer = action.payload
        state.isLoading = false
        state.error = null
      })
      .addCase(getCustomerSettings.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateCustomerSettings.pending, (state) => {
        state.isUpdating = true
        state.error = null
      })
      .addCase(updateCustomerSettings.fulfilled, (state, action) => {
        // Update the customer in the list
        const index = state.data.findIndex(c => c.id === action.payload.id)
        if (index !== -1) {
          state.data[index] = action.payload
        }
        // Update selected customer if it's the same one
        if (state.selectedCustomer && state.selectedCustomer.id === action.payload.id) {
          state.selectedCustomer = action.payload
        }
        state.isUpdating = false
        state.error = null
      })
      .addCase(updateCustomerSettings.rejected, (state, action) => {
        state.isUpdating = false
        state.error = action.error.message
      })
  }
})

export const { clearError, setSelectedCustomer } = appCustomersSettingsSlice.actions

export default appCustomersSettingsSlice.reducer
